import { Component } from '@angular/core';
import { Amplify } from 'aws-amplify';
import { fetchAuthSession } from 'aws-amplify/auth';
import { Router, ActivatedRoute } from '@angular/router';
import { CognitoService } from 'src/service/cognito.service';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';
const HASHKEY = 'B@j@j@123%&~SSO*7&%';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css'],
})
export class CallbackComponent {
  userPoolId: string = 'ap-south-1_KtZvAIiab';
  region: string = 'ap-south-1';
  clientId: any = '';
  userSession: any = '';
  token: any = '';
  redirectUrl: any = '';
  emailinvalid: boolean = false;
  loader: boolean = false;
  isUserInactive: boolean = false;
  userNotFound:boolean=false;
  constructor(
    private cognitoService: CognitoService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.clientId = params['clientId'] || null;
      if (this.clientId) {
        this.cognitoService.configureOAuth(this.clientId);
      }
    });

    const authSession = await fetchAuthSession();
    this.userSession = authSession.userSub;
    if (!this.userSession) {
      this.emailinvalid = true;
      return;
    }

    this.loader = true;

    const LastAuthUserName = `CognitoIdentityServiceProvider.${this.clientId}.LastAuthUser`;
    const LastAuthUserValue = localStorage.getItem(LastAuthUserName);
    const LastIdtokenName = `CognitoIdentityServiceProvider.${this.clientId}.${LastAuthUserValue}.idToken`;
    const LastAuthUser = localStorage.getItem(LastIdtokenName);
    this.token = LastAuthUser;

    if (
      [
        environment.b2b_insurance,
        environment.retirment_clientid,
        environment.surveypro_clientid,
        environment.bqdashboard_clientid,
        environment.post_retirement_clientid,
        environment.b2b_india_bonds_clientid,
        environment.DatacloudWM_clientid,
        environment.fpb2b_clientid,
        environment.digitalrm_clientid,
      ].includes(this.clientId)
    ) {
      localStorage.setItem('ssobauthToekn', this.token); // For B2B
    } else {
      localStorage.setItem('ssocauthToekn', this.token); // For B2C
    }
    const obj = { token: this.token, type: 'google' };

    // Conditionally call the appropriate Token API
    const tokenApiCall = [
      environment.b2b_insurance,
      environment.retirment_clientid,
      environment.surveypro_clientid,
      environment.bqdashboard_clientid,
      environment.post_retirement_clientid,
      environment.b2b_india_bonds_clientid,
      environment.DatacloudWM_clientid,
      environment.fpb2b_clientid,
      environment.digitalrm_clientid,
    ].includes(this.clientId)
      ? this.cognitoService.b2b_TokenApi(obj)
      : this.cognitoService.TokenApi(obj);

    await tokenApiCall.subscribe(
      async (data: any) => {
        const apiToken = data.body;
        // if (data.message === 'User not found') {
        //   this.userNotFound = true;
        //   this.loader = false;
        //   return;
        // }
        const decodedPayload = JSON.parse(atob(apiToken.split('.')[1]));

        // Check useractive ONLY for specific clientIds
        if (
          [
            environment.b2b_insurance,
            environment.retirment_clientid,
            environment.surveypro_clientid,
            environment.bqdashboard_clientid,
            environment.post_retirement_clientid,
            environment.b2b_india_bonds_clientid,
            environment.DatacloudWM_clientid,
            environment.fpb2b_clientid,
            environment.digitalrm_clientid,
          ].includes(this.clientId)
        ) {
          const userObj = { email: decodedPayload.email };
          this.cognitoService.useractive(userObj).subscribe((userData: any) => {
            const parsedBody = JSON.parse(userData.body);
            // Handle inactive user
            if (parsedBody && parsedBody.success && parsedBody.e_type === '2') {
              this.isUserInactive = true;
              return;
            }

            // Redirect if user is active
            this.handleRedirection(apiToken, decodedPayload.email);
          });
        } else {
          // Skip useractive check for other clientIds
          this.handleRedirection(apiToken, decodedPayload.email);
        }
      },
      (error) => {
        // console.log('Error during token API call', error);
      },
    );
  }

  handleRedirection(apiToken: string, email: string) {
    const b2bClients = [
      environment.b2b_insurance,
      environment.retirment_clientid,
      environment.surveypro_clientid,
      environment.bqdashboard_clientid,
      environment.post_retirement_clientid,
      environment.b2b_india_bonds_clientid,
      environment.DatacloudWM_clientid,
      environment.fpb2b_clientid,
      environment.digitalrm_clientid,
    ];

    const appType = b2bClients.includes(this.clientId) ? 2 : 1;

    this.logUserEvent(email, 'signIn with google', 'pass', '', appType);
    let obj = {
      token: apiToken,
    };
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(obj),
      HASHKEY,
    ).toString();
    var data = {
      data: ciphertext,
    };

    this.cognitoService.getSsoToken(data).subscribe((res: any) => {
      apiToken = res.token;
      this.token = apiToken;
      if (localStorage.getItem('ssocauthToekn')) {
        localStorage.setItem('ssocauthToekn', this.token);
      } else {
        localStorage.setItem('ssobauthToekn', this.token);
      }
      if (this.clientId === environment.nps_subdomain_clientid) {
        this.redirectUrl = `${environment.redirectUrlnps_subdomain}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.mf_clientid) {
        this.redirectUrl = `${environment.redirectUrlmf}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.insurance_clientid) {
        this.redirectUrl = `${environment.redirectUrlinsurance}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.b2b_insurance) {
        this.redirectUrl = `${environment.redirectUrlB2BINS}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.retirment_clientid) {
        this.redirectUrl = `${environment.retirment_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.surveypro_clientid) {
        this.redirectUrl = `${environment.surveypro_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.bqdashboard_clientid) {
        this.redirectUrl = `${environment.bqdashboard_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.b2b_india_bonds_clientid) {
        this.redirectUrl = `${environment.b2b_indiabonds_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.post_retirement_clientid) {
        this.redirectUrl = `${environment.post_retirement_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.b2c_insurance_clientid) {
        this.redirectUrl = `${environment.redirectionurl_b2c_insurance}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.b2c_india_bonds) {
        this.redirectUrl = `${environment.redirectionurl_b2c_indiabonds}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.unifieddashboard) {
        this.redirectUrl = `${environment.unifieddashboard_redirection}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.unifieddashboardcopy) {
        this.redirectUrl = `${environment.unifieddashboardcopy_redirection}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.DatacloudWM_clientid) {
        this.redirectUrl = `${environment.DatacloudWM_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.fpb2b_clientid) {
        this.redirectUrl = `${environment.fp_url}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.digitalrm_clientid) {
        this.redirectUrl = `${environment.digitalrm_url}?ssotoken=${apiToken}`;
      }
       else if (this.clientId === environment.fpb2c_clientid) {
        this.redirectUrl = `${environment.fpc_redirection}?ssotoken=${apiToken}`;
      } else if (this.clientId === environment.bcml_insurance) {
        this.redirectUrl = `${environment.bcml_insurance_redirection}?ssotoken=${apiToken}`;
      } else {
        // console.log('Redirecting to default client-specific page.');
      }

      window.location.href = this.redirectUrl;
    });
  }

  base64Decode(valueToDecode: string): any {
    const decodedData = JSON.parse(atob(valueToDecode));
    return decodedData;
  }

  async logUserEvent(
    userid: string,
    event_type: string,
    event_result: string,
    event_error: string,
    AppType: number,
  ) {
    let jscd: any = window[<any>'jscd'];

    // const ipResponse = await this.cognitoService.getIpAddress().catch((err) => {
    //   console.error('Failed to fetch IP address:', err);
    //   return null;
    // });

    const userevntobj = {
      userid,
      event_type,
      event_result,
      event_error,
      AppType,
      client_id: this.clientId,
      // ip_address: ipResponse || 'Unknown',
      ip_address:'Unknown',
      device: `${jscd?.browser} ${jscd?.os} ${jscd?.osVersion}`,
    };
    this.cognitoService.UserEventHistory(userevntobj).subscribe();
  }

  handleInvalidEmail() {
    this.router.navigate(['/sign-in'], {
      queryParams: { clientId: this.clientId },
    });
    localStorage.clear();
  }

  handleInactiveUser() {
    this.router.navigate(['/sign-in'], {
      queryParams: { clientId: this.clientId },
    });
    localStorage.clear();
    this.isUserInactive = false;
  }
}
